import React from "react";
import Page from "../components/Page";
import ScrollToTop from "../components/ScrollToTop";
import { patreonUrl, tgChatLink } from "../constants";
import { Button } from "react-bootstrap";

const AccessDenied = () => {
  return (
    <Page>
      <ScrollToTop />
      <h4 style={{ margin: "12px 0" }}>
        <i style={{ color: "red" }} className="bi bi-heart-fill"></i>
        &nbsp;Потребую вашої підтримки
      </h4>
      <img
        src="/maintenance.jpeg"
        style={{ width: "100%", height: 270, objectFit: "cover" }}
        alt="Poster"
      />
      <p style={{ marginTop: 12 }}>
        Щоб продовжити гру у{" "}
        <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>, необхідно
        оформити платну підписку на Patreon каналу ФЕНТЕЗІ ФУТБОЛ. ⚽
      </p>

      <p>
        Це допоможе мені розвивати проєкт і робити гру ще цікавішою для всіх
        учасників.{" "}
      </p>
      <p>Все дуже просто: </p>
      <p>
        ✅ Натисніть кнопку <strong>"Перейти на Patreon"</strong>.
      </p>
      <p>✅ Оберіть будь-який рівень підписки — від $1. </p>
      <p>
        ✅ Зачекайте деякий, після чого поверніться на сайт. 🎉 Підписка
        активується автоматично, і ви зможете знову насолоджуватися грою!{" "}
      </p>
      <p>
        Дякую за вашу підтримку та бажаю успіхів у{" "}
        <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>! 🚀{" "}
      </p>
      <Button
        style={{ fontSize: "1.3rem" }}
        onClick={() => window.open(patreonUrl, "_blank")}
      >
        <i className="bi bi-caret-right-fill"></i>&nbsp;Перейти на Patreon
      </Button>
      <Button
        variant="success"
        style={{ fontSize: "1.3rem", marginLeft: 8 }}
        onClick={() => window.open(tgChatLink, "_blank")}
      >
        <i className="bi bi-chat-left"></i>&nbsp;Чат
      </Button>
    </Page>
  );
};

export default AccessDenied;
